import CancelIcon from "@mui/icons-material/Cancel";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import GridViewIcon from "@mui/icons-material/GridView";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
} from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import { appImages } from "../../assets";
import { APP_ROUTES, AUTH_ROUTE } from "../../routes";
import { setUserData } from "../../lib/redux/slices/userSlice";
import { t } from "i18next";

const previewBtnStyle = {
  p: 1.5,
  bgcolor: "primary.main",
  width: "100%",
};

const CustomDrawer = ({ handleDrawerToggle }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const userData = useSelector((state) => state.userReducer.user);

  const renderProfile = () => {
    if (userData) {
      return (
        <Stack
          direction={"row"}
          alignItems={"center"}
          spacing={2}
          sx={previewBtnStyle}
        >
          <Avatar src={appImages.schoolBoyImage} />
          <Typography variant="body1" fontWeight={500} color={"text.white"}>
            {userData?.username}
          </Typography>
        </Stack>
      );
    } else {
      return (
        <Stack sx={previewBtnStyle} onClick={() => navigate("/login")}>
          <Typography variant="body1" fontWeight={500} color={"text.white"}>
            {t("getStarted")}
          </Typography>
        </Stack>
      );
    }
  };

  const renderConditionListItem = () => {
    if (userData) {
      return (
        <>
          <ListItem divider disablePadding>
            <ListItemButton
              onClick={() => {
                handleDrawerToggle();
                navigate("/dashboard");
              }}
            >
              <ListItemIcon
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "text.black",
                  },
                }}
              >
                <GridViewIcon />
              </ListItemIcon>
              <ListItemText primary={"Dashboard"} />
            </ListItemButton>
          </ListItem>
          <ListItem divider disablePadding>
            <ListItemButton
              onClick={() => {
                handleDrawerToggle();
                localStorage.removeItem("user_data");
                dispatch(setUserData(null));
                navigate("/");
              }}
            >
              <ListItemIcon
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "text.black",
                  },
                }}
              >
                <ExitToAppIcon />
              </ListItemIcon>
              <ListItemText primary={"Logout"} />
            </ListItemButton>
          </ListItem>
        </>
      );
    } else {
      return AUTH_ROUTE.slice(0, 2).map((val, index) => {
        const isActive = pathname === val.path;

        return (
          <ListItem
            key={index}
            divider
            disablePadding
            sx={{ bgcolor: isActive && "primary.light" }}
          >
            <ListItemButton
              onClick={() => {
                handleDrawerToggle();
                navigate(val.path);
              }}
            >
              <ListItemIcon
                sx={{
                  "& .MuiSvgIcon-root": {
                    color: "text.black",
                  },
                }}
              >
                {val.icon}
              </ListItemIcon>
              <ListItemText
                primary={t(val?.name)}
                sx={{ textTransform: "capitalize" }}
              />
            </ListItemButton>
          </ListItem>
        );
      });
    }
  };

  return (
    <Box onClick={handleDrawerToggle}>
      <Stack
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Typography variant="h6" sx={{ my: 2, px: 2 }}>
          EaziDay
        </Typography>
        <IconButton onClick={() => handleDrawerToggle()}>
          <CancelIcon />
        </IconButton>
      </Stack>

      <Divider />
      <List>
        <ListItem disablePadding>{renderProfile()}</ListItem>
        {APP_ROUTES.map((item, index) => {
          const isActive = pathname === item.path;
          return (
            <ListItem
              key={index}
              divider
              disablePadding
              sx={{ bgcolor: isActive && "primary.light" }}
            >
              <ListItemButton
                onClick={() => {
                  handleDrawerToggle();
                  navigate(item.path);
                }}
              >
                <ListItemIcon
                  sx={{
                    "& .MuiSvgIcon-root": {
                      color: "text.black",
                    },
                  }}
                >
                  {item.icon}
                </ListItemIcon>
                <ListItemText
                  primary={t(item.name)}
                  sx={{ textTransform: "capitalize" }}
                />
              </ListItemButton>
            </ListItem>
          );
        })}
        {renderConditionListItem()}
      </List>
    </Box>
  );
};

export default CustomDrawer;
